import DashboardIncidentsMainFiltered from './DashboardIncidentsMainFiltered';

export default DashboardIncidentsMainFiltered;
